"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paddingConfig = exports.customFontSizeConfig = exports.backgroundConfig = void 0;
var backgroundConfig = exports.backgroundConfig = {
  background: {
    brandLight: "var(--color-brand-light)",
    brandMid: "var(--color-brand-mid)",
    grey: "var(--color-global-grey200)",
    black: "var(--color-base-black)"
  },
  foreground: {
    brandMid: "var(--color-base-white)",
    black: "var(--color-base-white)"
  },
  anchorHover: {
    brandMid: "var(--color-global-grey200)",
    black: "var(--color-brand-light)"
  }
};
var customFontSizeConfig = exports.customFontSizeConfig = {
  size1: {
    xxs: 'M1',
    m: '1',
    l: '2'
  },
  size2: {
    xxs: '1',
    m: '2',
    l: '3'
  },
  size3: {
    xxs: '2',
    m: '3',
    l: '4'
  },
  size4: {
    xxs: '3',
    m: '4',
    l: '5'
  },
  size5: {
    xxs: '4',
    m: '5',
    l: '6'
  },
  size6: {
    xxs: '5',
    m: '6',
    l: '7'
  }
};
var paddingConfig = exports.paddingConfig = {
  paddingX: {
    xxs: 'var(--spacing-global-space5)',
    m: 'var(--spacing-global-space6)',
    l: 'var(--spacing-global-space7)'
  },
  paddingY: {
    xxs: 'var(--spacing-global-space6)',
    m: 'var(--spacing-global-space7)',
    l: 'var(--spacing-global-space8)'
  }
};